import { render, staticRenderFns } from "./NeiBuGongShi4.vue?vue&type=template&id=06acdb6d&scoped=true&"
import script from "./NeiBuGongShi4.vue?vue&type=script&lang=js&"
export * from "./NeiBuGongShi4.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuGongShi4.vue?vue&type=style&index=0&id=06acdb6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06acdb6d",
  null
  
)

export default component.exports